import { TFunction } from 'react-i18next';

export type TextString = ((t: TFunction) => string) | string;

export function getTextAsString(t: TFunction, stringText: TextString) {
    return typeof stringText === 'function' ? stringText(t) : stringText;
}
